import { resultTabActionTypes } from './Constants';

export function getResultTabSummary(exerciseId, groupId, query) {
	return {
		type: resultTabActionTypes.GET_RESULT_TAB_SUMMARY,
		payload: {
			exerciseId,
			groupId,
			query,
		},
	};
}

export function getResultTabSummarySuccess(data) {
	return {
		type: resultTabActionTypes.GET_RESULT_TAB_SUMMARY_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getResultTabSummaryError() {
	return {
		type: resultTabActionTypes.GET_RESULT_TAB_SUMMARY_ERROR,
	};
}

export function getResultTabResults(exerciseId, query) {
	return {
		type: resultTabActionTypes.GET_RESULT_TAB_RESULTS,
		payload: {
			exerciseId,
			query,
		},
	};
}

export function getResultTabResultsSuccess(data) {
	return {
		type: resultTabActionTypes.GET_RESULT_TAB_RESULTS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getResultTabResultsError() {
	return {
		type: resultTabActionTypes.GET_RESULT_TAB_RESULTS_ERROR,
	};
}
